import React from 'react';
import type { HeadingBlockContent } from '../../../types/popup.types';

interface HeadingBlockProps {
  content: HeadingBlockContent;
}

const HeadingBlock: React.FC<HeadingBlockProps> = ({ content }) => {
  const { text, tag, align, color, fontSize, fontWeight } = content;

  const Tag = tag || 'h2';
  
  // Align class
  const alignClass = align === 'center' ? 'text-center' : align === 'right' ? 'text-end' : 'text-start';
  
  // Font size class (Bootstrap utility)
  const sizeClass = fontSize ? '' : 'fs-3';

  const style: React.CSSProperties = {
    color: color || undefined,
    fontSize: fontSize ? `${fontSize}px` : undefined,
    fontWeight: fontWeight || 'bold',
    margin: 0,
  };

  return (
    <Tag 
      className={`mb-4 text-gray-800 ${alignClass} ${sizeClass}`} 
      style={style}
    >
      {text}
    </Tag>
  );
};

export default HeadingBlock;
